// extracted by mini-css-extract-plugin
export default {"compare-link":"mAZF70It--PaymentsComparisonLink_compare-link__+pwhb","compareLink":"mAZF70It--PaymentsComparisonLink_compare-link__+pwhb"};